import { createContext, useContext, useMemo } from "react";
import useSWR from "swr";
import Loading from "../../../components/Loaders/Loading";
import { useGroups } from "../General/OrganisationLevelGroups/context";
import { useCompany } from "../../../utils/hooks/company";

const CustomFieldsContext = createContext();

export const CustomFieldsProvider = ({ children }) => {
    const company = useCompany();
    const { data: { result: timesheetCustomFields }, isTimesheetLoading } = useSWR(
        company ? {
            url: "/custom-field/timesheet",
            params: { pagination: "false", company: company.id }
        } : null,
        { fallbackData: { result: [] } },
    );

    const { data: { result: peopleCustomFields }, isPeopleLoading } = useSWR(
        company ? {
            url: "/custom-field/people",
            params: { pagination: "false", company: company.id }
        } : null,
        { fallbackData: { result: [] } },
    );

    const value = useMemo(
        () => ({
            timesheetCustomFields,
            isTimesheetLoading,
            peopleCustomFields,
            isPeopleLoading,
        }),
        [isPeopleLoading, isTimesheetLoading, peopleCustomFields, timesheetCustomFields],
    );

    const { loading: loadingGroups } = useGroups();

    if (!!company && (loadingGroups || isTimesheetLoading || isPeopleLoading)) {
        return (
            <div className="d-flex justify-content-center align-items-center h-100">
                <Loading />
            </div>
        );
    }

    return (
        <CustomFieldsContext.Provider value={value}>
            {children}
        </CustomFieldsContext.Provider>
    );
};

export const useCustomFields = () => {
    const context = useContext(CustomFieldsContext);
    if (context === undefined) {
        throw new Error("'useCustomFields' has to be used inside a provider");
    }
    return context;
};
